<article class="team-card" [style.borderTopColor]="team.color">
  <app-text
    [type]="TextType.BODY"
    [size]="TextSize.TITLE_0"
    [height]="TextHeight.SMALLER"
    [weight]="TextWeight.REGULAR"
    [color]="TextColor.NEUTRAL_6"
    [spacingBottom]="TextSpacing.X_SMALL"
  >
    {{ team.rank }}{{ getOrdinalSuffix(team.rank) }}
  </app-text>
  <div class="team-details">
    <h3 class="team-name">{{ team.name }}</h3>
    <p class="team-score">{{ team.score }}</p>
  </div>
  <app-text
    [type]="TextType.BODY"
    [size]="TextSize.TITLE_0"
    [height]="TextHeight.SMALLER"
    [weight]="TextWeight.REGULAR"
    [color]="TextColor.NEUTRAL_6"
    [spacingBottom]="TextSpacing.MEDIUM"
  >
    {{ getParticipants() }}
  </app-text>
  <ul data-test-id="team-card-subteam-list">
    @for (team of subTeamlist; track $index) {
    <li data-test-id="team-card-subteam-item">
      <span class="rank">{{ team.rank }}</span>
      <div class="name-score">
        {{ team.name }}
        <span class="score">{{ team.score }}</span>
      </div>
    </li>
    }
  </ul>
  <a
    [routerLink]="leaderboardLink"
    class="link"
    data-test-id="team-card-leaderboard-link"
    >View Leaderboard</a
  >
</article>
